import { render, staticRenderFns } from "./PcClientSideNavigationItem.vue?vue&type=template&id=2e91f5ec"
import script from "./PcClientSideNavigationItem.vue?vue&type=script&lang=js"
export * from "./PcClientSideNavigationItem.vue?vue&type=script&lang=js"
import style0 from "./PcClientSideNavigationItem.vue?vue&type=style&index=0&id=2e91f5ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VListItem,VListItemContent,VListItemIcon,VListItemTitle,VTooltip})
